import { Component, Input } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { AtwUpdateDbComponent } from 'vhobjects-service/src/services';
import { FunctionService} from 'vhobjects-service/src/services';

@Component({
  selector: 'atw-line-config',
  templateUrl: './line-config.component.html',
  styleUrls: ['./line-config.component.scss']
})
export class AtwLineConfig extends AtwUpdateDbComponent {

  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() type: any; // xác định trang ở page hay preview

  openMap: { [name: string]: boolean } = {
    menu1: false,
    menu2: true,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false
  };
  //Mảng chứa kiểu line
  dataLines = [
    {
      name: 'solid',
      point: 0,
      title: 'horizontal'
    },
    {
      name: 'solid',
      point: 0,
      title: 'vertical'
    },
    {
      name: 'solid',
      point: 0,
      title: 'top-left'
    },
    {
      name: 'solid',
      point: 0,
      title: 'bottom-left'
    },
    {
      name: 'solid',
      point: 0,
      title: 'top-right'
    },
    {
      name: 'solid',
      point: 0,
      title: 'bottom-right'
    },
  ];
  

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhEventMediator: VhEventMediator,
        public functionService: FunctionService
  ) { 
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }


  // //Hàm update class
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
        
  //     })
  // }

  // //Hàm update class
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //     .then((bool: any) => {
        
  //     })

  // }
  //   /**
  //  * Hàm update object vào database.
  //  */
  //   updateObject() {
  //     this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //       .then((bool: any) => {
          
  //       })
  //   }

  
  /**
   * Chọn các options đường viền
   * @param name : trả về mẫu đường viền đã chọn
   */
  chooseLine(name) {
    const border_shape = this.class.line__type
    const config = this.config
    // this.config['border_width'] = this.class.line__type['border-width'];
    const border_left_width = this.config['border-left-width']
    const border_top_width = this.config['border-top-width']
    const border_bottom_width = this.config['border-bottom-width']
    const border_right_width = this.config['border-right-width']
    switch (name) {
      case 'horizontal':
        config.border_title = "horizontal"
        border_shape.height = "100%";
        border_shape.width = "100%";
        border_shape.left = "0%";
        border_shape.top = "50%";
        border_shape.position = "relative";
        border_shape.transform = `rotate(0deg)`
        border_shape.background = "none";
        border_shape['border-top-width'] = border_top_width
        border_shape['border-left-width'] ="0"
        border_shape['border-bottom-width'] = "0"
        border_shape['border-right-width'] = "0"
        border_shape['border-style'] = `${this.class.line__type['border-style']}`;
        break;
      case 'vertical':
        border_shape.height = "100%";
        border_shape.width = "100%";
        config.border_title = "vertical";
        border_shape.position = "relative";
        border_shape.left = "50%";
        border_shape.top = "0%";
        border_shape.background = "none";
        border_shape['border-top-width'] = "0"
        border_shape['border-left-width'] = border_left_width
        border_shape['border-bottom-width'] = "0"
        border_shape['border-right-width'] = "0"
        border_shape['border-style'] = `${this.class.line__type['border-style']}`;
        break;
      case 'top-left':
        config.border_title = "top-left";
        border_shape.height = "100%";
        border_shape.width = "100%";
        border_shape.point = 0;
        border_shape.top = 0;
        border_shape.left = "0%";
        border_shape.top = "0%";
        border_shape.background = "none";
        border_shape['border-top-width'] = border_top_width
        border_shape['border-left-width'] = border_left_width
        border_shape['border-bottom-width'] = "0"
        border_shape['border-right-width'] = "0"
        border_shape['border-style'] = `${this.class.line__type['border-style']}`;
        break;
      case 'bottom-left':
        config.border_title = 'bottom-left';
        border_shape.height = "100%";
        border_shape.width = "100%";
        border_shape.left = "0%";
        border_shape.top = "0%";
        border_shape.transform = `rotate(0deg)`
        border_shape.background = "none";
        border_shape['border-top-width'] = "0"
        border_shape['border-right-width'] = "0"
        border_shape['border-bottom-width'] = border_bottom_width
        border_shape['border-left-width'] = border_left_width
        border_shape['border-style'] = `${this.class.line__type['border-style']}`;
        border_shape.point = 0;
        break;
      case 'top-right':
        config.border_title = 'top-right';
        border_shape.height = "100%";
        border_shape.width = "100%";
        border_shape.left = "0%";
        border_shape.top = "0%";
        border_shape.transform = `rotate(0deg)`
        border_shape.background = "none";
        border_shape['border-top-width'] = border_left_width
        border_shape['border-right-width'] = border_right_width
        border_shape['border-left-width'] = "0"
        border_shape['border-bottom-width'] = "0"
        border_shape['border-style'] = `${this.class.line__type['border-style']}`;
        border_shape.point = 0;

        break;
      case 'bottom-right':
        config.border_title = 'bottom-right';
        border_shape.height = "100%";
        border_shape.width = "100%";
        border_shape.point = 0;
        border_shape.left = "0%";
        border_shape.top = "0%";
        border_shape.transform = `rotate(0deg)`
        border_shape.background = "none";
        border_shape['border-bottom-width'] = border_bottom_width
        border_shape['border-right-width'] = border_right_width
        border_shape['border-top-width'] = "0"
        border_shape['border-left-width'] = "0"
        border_shape['border-style'] = `${this.class.line__type['border-style']}`;
        break;
      case 'top-bottom-left-right':
        config.border_title = 'top-bottom-left-right';
        border_shape.point = 0;
        border_shape.left = "0%";
        border_shape.top = "0%";
        border_shape.transform = `rotate(0deg)`
        border_shape.background = "none";
        border_shape['border-bottom-width'] = border_bottom_width
        border_shape['border-right-width'] =border_right_width
        border_shape['border-top-width'] = border_top_width
        border_shape['border-left-width'] = border_left_width
        border_shape['border-style'] = `${this.class.line__type['border-style']}`;
        break;
      default:
        break;
    }
    this.updateObject();
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }


  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['line']['width'] = event.width + 'px';
    if (event.height) this.class['line']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }

}
